import React from 'react';
import Icon from '@components/common/assets';
import KakaoMap from '@components/position/jd/map/KakaoMap';
import { PositionDetailVO } from '@domain/vo/position/jd/PositionDetailVO';
import classnames from 'classnames/bind';
import styles from './map.module.scss';
const cx = classnames.bind(styles);

interface MapProps {
  positionDetail: PositionDetailVO;
}

const Map = ({ positionDetail }: MapProps) => {
  const { basicInfo } = positionDetail;
  const { address } = basicInfo;
  if (!address) return null;

  return (
    <div className={cx('mapWrap')}>
      <div className={cx('titleArea')}>
        <Icon name="workLight" width={32} height={32} />
        <em className={cx('title')}>여기서 근무해요.</em>
      </div>
      <KakaoMap address={address} />
    </div>
  );
};

export default Map;
